import { get, put } from 'helpers/api';
import { STEPS, STEPS_LABELS } from '../../constants';
import {
  getCurrentFile,
  getColumnMappings,
  getFileMapping,
  getIgnoredRecordIndex,
  getImport,
  getPaths,
  getRecordIndex
} from '../selectors';
import { setImport } from './importer';

export const SET_DEFAULT_MAPPINGS = 'importRequest/SET_DEFAULT_MAPPINGS';
export const setDefaultMappings = fileMapping => ({
  type: SET_DEFAULT_MAPPINGS,
  ...fileMapping
});

export const SET_REQUIRED_FIELDS = 'importRequest/SET_REQUIRED_FIELDS';
export const setRequiredFields = file => ({
  type: SET_REQUIRED_FIELDS,
  file
});

export const SET_RECORD_INDEX = 'importRequest/SET_RECORD_INDEX';
export const setRecordIndex = index => ({
  type: SET_RECORD_INDEX,
  index
});

export const SET_IGNORED_RECORD_INDEX = 'importRequest/SET_IGNORED_RECORD_INDEX';
export const setIgnoredRecordIndex = ignoredRecordIndex => ({
  type: SET_IGNORED_RECORD_INDEX,
  ignoredRecordIndex
});

export const SET_FILE_RECORD = 'importRequest/SET_FILE_RECORD';
export const setFileRecord = record => ({
  type: SET_FILE_RECORD,
  record
});

export const SET_IGNORED_FILE_RECORD = 'importRequest/SET_IGNORED_FILE_RECORD';
export const setIgnoredFileRecord = ignoredRecord => ({
  type: SET_IGNORED_FILE_RECORD,
  ignoredRecord
});

export const SET_MERGE_STRATEGY = 'importRequest/SET_MERGE_STRATEGY';
export const setMergeStrategy = mergeStrategy => ({
  type: SET_MERGE_STRATEGY,
  mergeStrategy
});

export const getMappingRequiredFields = () => (
  (dispatch, getState) => {
    const state = getState();
    const paths = getPaths(state);
    const file = getCurrentFile(state);
    const importer = getImport(state);

    return get(paths.import + `/${importer.id}/required_fields`, {
      params: { fileId: file.id }
    })
      .then((response) => {
        dispatch(setDefaultMappings(response));
      });
  }
);

export const getFileRecord = isIgnored => (
  (dispatch, getState) => {
    const state = getState();
    const file = getCurrentFile(state);
    const index = isIgnored  ? getIgnoredRecordIndex(state) : getRecordIndex(state);
    if (!file.id) return;

    return get(`${file.filePath}/records`, {
      params: { index }
    })
      .then((response) => {
        if (!response.record) return;
        if (isIgnored) {
          dispatch(setIgnoredFileRecord(response.record));
        } else {
          dispatch(setFileRecord(response.record));
        }
      });
  }
);

export const saveFileMapping = () => (
  (dispatch, getState) => {
    const state = getState();
    const paths = getPaths(state);
    const importer = getImport(state);
    const fileMapping = getFileMapping(state);
    const columnMappings = getColumnMappings(state);

    return put(`${paths.import}/${importer.id}/runs/${fileMapping.runId}/file_mappings/${fileMapping.id}`, {
      importerFileMapping: {
        ...fileMapping,
        columnMappingsAttributes: columnMappings.map(({ columnMapping }) => columnMapping)
      }
    })
      .then((response) => {
        const statusType = STEPS[STEPS_LABELS.PREVIEW].status;
        dispatch(setImport({ ...importer, statusType }));

        return response.fileMapping;
      });
  }
);
